import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router'
import store, { hasLoginToken, hasUsableLoginState } from './store'
import userApi from './api/user'

Vue.use(Vant);
Vue.config.productionTip = false

// 2026-10-05：先注册登录保护，再启动页面，确保刷新 /home 也会先检查登录。
// 只在首次进入业务页时向服务端确认令牌；普通页面切换和后台恢复不重复检查。
router.beforeEach(async (to, from, next) => {
  if (!to.matched.some(record => record.meta.auth)) {
    next()
    return
  }

  if (hasLoginToken(store.state) && from.matched.length === 0) {
    const token = store.state.token
    try {
      const response = await userApi.validateToken()
      const result = response.data
      // 校验等待期间若已退出或换了账号，不能用旧请求覆盖新的登录信息。
      if (store.state.token === token && hasLoginToken(store.state)) {
        if (result && Number(result.code) === 401) {
          store.commit('logout')
        } else if (result && Number(result.code) === 1 && hasUsableLoginState({ isLogin: true, token, user: result.data })) {
          // 用户资料暂时缺失时，用已有接口恢复；令牌保持原值，不要求重复登录。
          store.commit('login', { msg: token, data: result.data })
        } else {
          console.warn('登录检查返回异常，保留原登录记录')
        }
      }
    } catch (error) {
      // 超时、断网或服务端暂时故障不等于令牌失效，不能因此删除有效缓存。
      console.warn('暂时无法检查登录，保留原登录记录')
    }
  }

  if (store.getters.getLoginState) {
    next()
  } else {
    next({ name: 'Login', replace: true })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
